/* eslint-disable no-console */
export const redirectToWhatsApp = (phoneNumber: string, message?: string): void => {
	try {
		const cleanPhoneNumber = phoneNumber.replace(/\D/g, '');

		let whatsappUrl = `https://wa.me/+55${cleanPhoneNumber}`;

		if (message) {
			const encodedMessage = encodeURIComponent(message);
			whatsappUrl += `?text=${encodedMessage}`;
		}

		window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
	} catch (error) {
		console.error('Erro ao redirecionar para o WhatsApp:', error);
	}
};
